<template>
    <div>
        <template v-if="isBusy">
            <Preloader/>
        </template>
        <template v-else>
            <form class="form" method="POST" name="devis_panne_mecanique_standard" @submit.prevent="submit">
                <div class="col-12">
                    <div class="page__head-title page__head-title--orange">
                        <div class="page__head-title__text page__head-title__text--orange">Nouvelle attestation</div>
                        <div class="page__head-title__notice">(* champs obligatoires)</div>
                    </div>
                </div>
                <div class="row">
                    <!--vehicle block-->
                    <div class="col-12">
                        <div class="form_ttl">Informations sur le véhicule à assurer:</div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Immatriculation</div>
                            <div class="form__item__input-wrapper">
                                <Multiselect
                                    v-model="attestation.driving_school_car"
                                    :options="vehiclesList"
                                    label="registration_number"
                                    value="id"
                                    placeholder="Sélectionnez un véhicule"
                                    :searchable="false"
                                    :show-labels="false"
                                    :allow-empty="false">

                                    <span slot="noOptions">Aucun véhicule</span>

                                </Multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label">Véhicule</div>
                            <div class="form__item__input-wrapper">
                                <!--                            <input class="input_n"/>-->
                                {{attestation.driving_school_car ? attestation.driving_school_car.car_brand : ''}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label">Modèle</div>
                            <div class="form__item__input-wrapper">
                                <!--                            <input class="input_n"/>-->
                                {{attestation.driving_school_car ? attestation.driving_school_car.car_model : ''}}
                            </div>
                        </div>
                    </div>

                    <!--teacher block-->

                    <div class="col-12">
                        <div class="form_ttl">Informations sur l'accompagnateur à assurer:</div>
                    </div>

                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Inscription</div>
                            <div class="form__item__input-wrapper form__item__input-wrapper--checkbox">
                                <input v-model="attestation.inscription" type="radio" value="1"/> Oui
                                <input v-model="attestation.inscription" type="radio" value="0"/> Non
                            </div>
                        </div>
                    </div>
                    <!--                -->
                    <template v-if="inscriptionActive">
                        <div class="col-12">
                            <div class="form__item">
                                <div class="form__item__label form__item__label--required">Nom</div>
                                <div class="form__item__input-wrapper">
                                    <input class="input_n" v-model="attestation.teacher_first_name"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form__item">
                                <div class="form__item__label form__item__label--required">Prenom</div>
                                <div class="form__item__input-wrapper">
                                    <input class="input_n" v-model="attestation.teacher_last_name"/>
                                </div>
                            </div>
                        </div>
<!--                        <div class="col-12">-->
<!--                            <div class="form__item">-->
<!--                                <div class="form__item__label form__item__label&#45;&#45;required">Addresse</div>-->
<!--                                <div class="form__item__input-wrapper">-->
<!--                                    <input class="input_n" v-model="attestation.teacher_address"/>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-12">-->
<!--                            <div class="form__item">-->
<!--                                <div class="form__item__label form__item__label&#45;&#45;required">Code postal</div>-->
<!--                                <div class="form__item__input-wrapper">-->
<!--                                    <input class="input_n" v-model="attestation.teacher_zip"/>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-12">-->
<!--                            <div class="form__item">-->
<!--                                <div class="form__item__label form__item__label&#45;&#45;required">Ville</div>-->
<!--                                <div class="form__item__input-wrapper">-->
<!--                                    <input class="input_n" v-model="attestation.teacher_city"/>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </template>
                    <!---->

                    <!--candidate block-->
                    <div class="col-12">
                        <div class="form_ttl">Informations sur le candidat à assurer:</div>
                    </div>


                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Nom</div>
                            <div class="form__item__input-wrapper">
                                <input class="input_n" v-model="attestation.candidate_first_name"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Prenom</div>
                            <div class="form__item__input-wrapper">
                                <input class="input_n" v-model="attestation.candidate_last_name"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Addresse</div>
                            <div class="form__item__input-wrapper">
                                <input class="input_n" v-model="attestation.candidate_address"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Code postal</div>
                            <div class="form__item__input-wrapper">
                                <input class="input_n" v-model="attestation.candidate_zip"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Ville</div>
                            <div class="form__item__input-wrapper">
                                <input class="input_n" v-model="attestation.candidate_city"/>
                            </div>
                        </div>
                    </div>
<!--                    <div class="col-12">-->
<!--                        <div class="form__item">-->
<!--                            <div class="form__item__label form__item__label&#45;&#45;required">Date de l'examen</div>-->
<!--                            <div class="form__item__input-wrapper form__item__input-wrapper&#45;&#45;date">-->
<!--                                <the-mask :mask="['##/##/####']" v-model="attestation.exam_date_string"/>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Date de l'examen</div>
                            <div class="form__item__input-wrapper form__item__input-wrapper--date">
                                <div class="label currency-datepicker">
                                    <div class="label__input-wrap">
                                        <datepicker placeholder="De"
                                                    format="DD/MM/YYYY"
                                                    :monday-first="true"
                                                    :full-month-name="true"
                                                    wrapper-class="currency-datepicker__wrapper-low-margin mb-3"
                                                    input-class="currency-datepicker__input"
                                                    calendar-class="currency-datepicker__element bottom-100"
                                                    v-model="attestation.exam_date"
                                                    :highlighted="attestation.exam_date ? '' : highlightedConfig">
                                        </datepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--submit-->
                    <div class="col-12">
                        <div class="form__item justify-content-center mt-3 mb-3">
                            <div class="form__item__submit">
                                <input type='submit' name="Submit" value="Envoyer"
                                       class="form_bt form_confirm_button form__item__submit__button"/>
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </template>
    </div>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required, requiredIf} from 'vuelidate/lib/validators'
    import Multiselect from 'vue-multiselect'
    import {TheMask} from 'vue-the-mask'
    import {DRIVING_SCHOOOL_CONST} from "@/driving_school_consts";
    import Datepicker from '@/components/DatepickerCustom/src/components/Datepicker'
    export default {
        name: 'DrivingLicenceAttestation',
        components: {Multiselect, TheMask, Datepicker},
        mixins: [validationMixin],
        props: {
            attestation_type: {
                type: Number,
                required: true,
            }
        },
        data() {
            return {
                attestation: {
                    driving_school_car: null,
                    inscription: null,
                    teacher_first_name: null,
                    teacher_last_name: null,
                    candidate_first_name: null,
                    candidate_last_name: null,
                    candidate_address: null,
                    candidate_city: null,
                    candidate_zip: null,
                    exam_date: null,
                },
                vehiclesList: [],
                isBusy: false,
                highlightedConfig: {
                    dates: [new Date()],
                }
            }
        },
        computed: {
            isNew() {
                return !this.$route.params.id;
            },
            inscriptionActive() {
                return this.attestation.inscription == 1;
            }
        },
        watch: {
            attestation_type() {
                this.$root.clearObjectValues(this.attestation);
            }
        },
        methods: {
            getVehiclesList() {
                let url = `driving_school_cars`,
                    data = {
                        per_page: 'All',
                        // in_park_now: 1,
                        exit_date_start: this.moment().format('YYYY-MM-DD HH:mm:ss')
                    };
                this.apiGet(url, data)
                    .then(response => {
                        console.log(response.data.data);
                        this.vehiclesList = response.data.data;
                    })
                    .catch(error => {
                        this.showErrorNotification(error);
                    })
            },
            createAttestation() {
                if (!this.$v.$invalid) {
                    let url = `driving_school_attestations`,
                        data = this.attestation;
                    data.driving_school_car_id = data.driving_school_car.id;
                    data.attestation_type = this.attestation_type;
                    data.exam_date_string = this.moment(this.attestation.exam_date).format('DDMMYYYY');
                    console.log(data.exam_date_string);
                    this.apiPost(url, data)
                        .then(response => {
                            console.log(response.data);
                            this.nextStep(response.data.id);
                        })
                        .catch(error => {
                            this.showErrorNotification(error, '');
                        })
                } else {
                    this.showWarningNotification('Veuillez remplir tous les champs obligatoires.')
                }
            },
            getAttestation() {
                let url = `driving_school_attestations/${this.$route.params.id}`;
                this.isBusy = true;
                this.apiGet(url)
                    .then(response => {
                        console.log(response.data);
                        this.parseData(response.data);
                    })
                    .catch(error => {
                        console.log(error);
                        this.showErrorNotification(error);
                    })
                    .finally(() => {
                        this.isBusy = false;
                    })
            },
            parseData(response) {
                this.attestation.driving_school_car = response.driving_school_car;
                this.attestation.inscription = response.inscription;

                if (response.driving_school_teacher) {
                    this.attestation.teacher_first_name = response.driving_school_teacher.first_name;
                    this.attestation.teacher_last_name = response.driving_school_teacher.last_name;
                    this.attestation.teacher_address = response.driving_school_teacher.address;
                    this.attestation.teacher_city = response.driving_school_teacher.city;
                    this.attestation.teacher_zip = response.driving_school_teacher.zip;
                }

                this.attestation.candidate_first_name = response.driving_school_candidate.first_name;
                this.attestation.candidate_last_name = response.driving_school_candidate.last_name;
                this.attestation.candidate_address = response.driving_school_candidate.address;
                this.attestation.candidate_city = response.driving_school_candidate.city;
                this.attestation.candidate_zip = response.driving_school_candidate.zip;

                this.attestation.exam_date = new Date(response.exam_date);

            },
            editAttestation() {
                if (!this.$v.$invalid) {
                    let url = `driving_school_attestations/${this.$route.params.id}`,
                        data = this.attestation;
                    data.driving_school_car_id = data.driving_school_car.id;
                    data.exam_date_string = this.moment(this.attestation.exam_date).format('DDMMYYYY');

                    this.apiUpdate(url, data)
                        .then(response => {
                            console.log(response.data);
                            this.nextStep(response.data.id);
                        })
                        .catch(error => {
                            console.log(error);
                            this.showErrorNotification(error, '');
                        })
                } else {
                    this.showWarningNotification('Veuillez remplir tous les champs obligatoires.');
                }
            },
            submit() {
                this.isNew ? this.createAttestation() : this.editAttestation();
            },
            nextStep(id) {
                switch (this.attestation_type) {
                    case DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.DRIVING_LICENCE.KEY:
                        this.$router.push(`/double_commande/double_commande_attestation_view/${id}`);
                        break;
                    case DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.VTC.KEY:
                        this.$router.push(`/double_commande/vtc_attestation_view/${id}`);
                        break;
                    case DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.BEPECASER.KEY:
                        this.$router.push(`/double_commande/bepecaser_attestation_view/${id}`);
                        break;
                }
            }

        },
        mounted() {
            this.getVehiclesList();
            if (!this.isNew) this.getAttestation();
        },
        validations: {
            attestation: {
                driving_school_car: {
                    required,
                },
                teacher_first_name: {
                    required: requiredIf(function () {
                        return !!this.inscriptionActive;
                    })
                },
                teacher_last_name: {
                    required: requiredIf(function () {
                        return !!this.inscriptionActive;
                    })
                },
                candidate_first_name: {
                    required,
                },
                candidate_last_name: {
                    required,
                },
                candidate_address: {
                    required,
                },
                candidate_city: {
                    required,
                },
                candidate_zip: {
                    required,
                },
                exam_date: {
                    required,
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/DrivingSchool/DrivingLicenceAttestation/DrivingLicenceAttestation.vue